import { HTMLAttributes } from "react";
import "./progress-indicator.scss";

//<editor-fold desc="Props">
export interface ProgressIndicatorDOMProps
  extends HTMLAttributes<HTMLDivElement> {}

export interface ProgressIndicatorProps extends ProgressIndicatorDOMProps {
  show: boolean;
  backdrop?: boolean;
  variant?: "sm"|"lg";
}
//</editor-fold>

function ProgressIndicator(props: ProgressIndicatorProps) {
  //<editor-fold desc="Local variables">
  let {
    show,
    backdrop,
    variant,
  } = props;
  //</editor-fold>
  const spinner = <div className={"spinner fade" + (show ? " show" : "") + (variant ? " spinner-" + variant : "")}></div>;
  if (backdrop) {
    return (
      <div
          className={"spinner-backdrop fade" + (show ? " show" : "")}
          tabIndex={-1}
          role="progressbar"
      >
        {spinner}
      </div>
    );
  } else {
    return spinner;
  }

}
export default ProgressIndicator;
